import React from "react"

import AdminDrawer from "../../components/AdminDrawer"
import AdminDashboardComponent from "../../components/AdminDashboard"

const AdminDashboard = () => {
    return (
        <AdminDrawer child={<AdminDashboardComponent />} />
    )
}

export default AdminDashboard
